export const padTo2Digits = (num: number): string => {
  return num.toString().padStart(2, '0');
};

export const formatDate = (): string => {
  const date = new Date();
  return (
    [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-') +
    'T' +
    [
      padTo2Digits(date.getHours()),
      padTo2Digits(date.getMinutes()),
      padTo2Digits(date.getSeconds()),
    ].join('') +
    'M' +
    [padTo2Digits(date.getMilliseconds())].join('')
  );
};

export const getSuggestedFileName = (
  prefix: string = 'PlumeSignalHealth-',
): string => {
  return `${prefix}${formatDate()}.csv`.replace(/[?<>:\\/*/"/?]/g, '');
};

export const validateCsvFilename = (filename: string) => {
  const rg1 = /^[^\\/:*?"<>|]+$/;
  const rg2 = /^\./;
  const rg3 = /^(nul|prn|con|lpt[0-9]|com[0-9])(\.|$)/i;
  const rg4 = /^.*\.csv$/;
  return !(
    rg1.test(filename) &&
    !rg2.test(filename) &&
    !rg3.test(filename) &&
    rg4.test(filename)
  );
};

/**
 * Returns the text color (proper contrast) that should be used for a given background color.
 * @param backgroundColor The background color to determine the text color for.
 */
export const textColorForBackground = (backgroundColor: string) => {
  backgroundColor = backgroundColor.substring(1);
  const r = parseInt(backgroundColor.substring(0, 2), 16);
  const g = parseInt(backgroundColor.substring(2, 4), 16);
  const b = parseInt(backgroundColor.substring(4, 6), 16);

  const srgb = [r / 255, g / 255, b / 255];
  const x = srgb.map((i) => {
    if (i <= 0.04045) {
      return i / 12.92;
    } else {
      return Math.pow((i + 0.055) / 1.055, 2.4);
    }
  });

  const L = 0.2126 * x[0] + 0.7152 * x[1] + 0.0722 * x[2];
  return L > 0.179 ? '#000' : '#fff';
};
